import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, EmailAuthProvider } from "firebase/auth";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDrZmBiO2508oOv3dj14_JTfE8Y-PN9YcY",
  authDomain: "goodbones-483514.firebaseapp.com",
  projectId: "goodbones-483514",
  storageBucket: "goodbones-483514.firebasestorage.app",
  messagingSenderId: "126421969556",
  appId: "1:126421969556:web:9f33ac05d0905718b06281",
  measurementId: "G-CT4L0RP6R9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth
export const auth = getAuth(app);

// Initialize Firestore
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
export const emailProvider = new EmailAuthProvider();

// Initialize Analytics
export const analytics = getAnalytics(app);

// Helper to log custom events
export const logAnalyticsEvent = (eventName: string, eventParams?: Record<string, any>) => {
  logEvent(analytics, eventName, eventParams);
};

export default app;

